
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gp4JB74tdttbsQZFBO3CGjoDU9mmVdr9vkbl6e8mwAv4Meta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexIbTOCv79p0vnao2KnqX_cMw1Dw8rM1EyL0UfR7gYbVYMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchTkel3tIER4Q1her8DUUmG9IREWBircu5VKOPiPxQ1kYMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexfqMydQM6m6Fgy4j07AVC00I8g6y7tAlBsNhEqDnfCoIMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93ePjauSmyzk_b1NChI7_45ZLWVzxMCvpGK5jUPyeUOkmjgMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as index1P0H8bIPwABO6MxNBNBfjjbEYa67LikDTeWqkFltLqEMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93ebPc6fwyxdP78oUbq04RNCqZq9qH53kKFqqBnyEsmNQMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexvSpT0qShiAqOcDJkTRQP9GWYTYOCIDPutvCDibmZGT4Meta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93GjgkOFg60xBriJ79jteQEJzH2SAgpDFHRA1n1A5M8CoMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as index3FqT_PH7c9vNDzQEf2tS_HBk6yq96YoNmRRkZZq_NG4Meta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexv1SMxM0jGcQ_cFE91FJkc0DfdUbr4kq6RHWSl41_6eYMeta } from "/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: index1P0H8bIPwABO6MxNBNBfjjbEYa67LikDTeWqkFltLqEMeta || {},
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexvSpT0qShiAqOcDJkTRQP9GWYTYOCIDPutvCDibmZGT4Meta || {},
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: index3FqT_PH7c9vNDzQEf2tS_HBk6yq96YoNmRRkZZq_NG4Meta || {},
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexv1SMxM0jGcQ_cFE91FJkc0DfdUbr4kq6RHWSl41_6eYMeta || {},
    component: () => import("/codebuild/output/src4265762264/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]